import React from 'react';
import { Users } from 'lucide-react';

const AnnouncementBanner = () => {
  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-[#DFFF00] text-black py-1.5 px-4">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-2 text-xs sm:text-sm font-medium whitespace-nowrap">
        <Users className="w-4 h-4 flex-shrink-0" />
        <span>
          <strong>Phocea Rent</strong> est dédié aux <strong>prestataires de l'événementiel</strong>
        </span>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
